<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'协同管理'},{title:'协同部门配置'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="客户名称" >
                              <el-input v-model="q.customerCode" placeholder="请输入名称" :clearable="true"></el-input>
                            </el-form-item>
                          <el-form-item label="区域">
                            <el-select filterable v-model="q.area" clearable placeholder="请选择">
                              <el-option
                                  v-for="(item,index) in areaList"
                                  :key="item.name"
                                  :label="item.name"
                                  :value="item.name">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="渠道">
                            <el-select filterable v-model="q.channel" clearable placeholder="请选择"
                            >
                              <el-option
                                  v-for="(item,index) in channelList"
                                  :key="item.name"
                                  :label="item.name"
                                  :value="item.name">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="用户(业主)">
                            <el-input v-model="q.user" placeholder="请输入名称" :clearable="true"></el-input>
                          </el-form-item>
                        </div>
                        <div class="h-thirdColumn w-newColumn">
                          <el-form-item label="数据来源">
                              <el-select v-model="q.dataSource"
                                           placeholder="请选择"
                                           clearable>
                                  <el-option label="公海录入" value="公海录入"></el-option>
                                  <el-option label="线索" value="线索"></el-option>
                                  <el-option label="海宝汇" value="海宝汇"></el-option>
                              </el-select>
                          </el-form-item>
                            <el-form-item label="创建时间" prop="cdate" style="width: 50%;">
                                <el-date-picker
                                    v-model="q.cstartDate"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                                </el-date-picker>
                                <span class="w-time-to">至</span>
                                <el-date-picker
                                    v-model="q.cendDate"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                                </el-date-picker>
                            </el-form-item>

                        </div>
                      <div class="l-screenBox">
                        <div class="l-retrieval">
                          <el-form-item>
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="adduser">新增
                            </el-button>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              :border="true"
                              stripe
                              max-height="500"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#">
                        </el-table-column>

                        <el-table-column
                                prop="area"
                                :show-overflow-tooltip="true"
                                label="区域">
                        </el-table-column>
                        <el-table-column
                            prop="city"
                            :show-overflow-tooltip="true"
                            label="地市">
                        </el-table-column>
                        <el-table-column
                                prop="channel"
                                :show-overflow-tooltip="true"
                                label="渠道">
                        </el-table-column>
                        <el-table-column
                                prop="customerName"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="客户名称">
                        </el-table-column>
<!--                        <el-table-column-->
<!--                            prop="custagentName"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            width="100"-->
<!--                            label="领域">-->
<!--                        </el-table-column>-->
                        <el-table-column
                            prop="majorBrands"
                            :show-overflow-tooltip="true"
                            width="180"
                            label="主要经营品牌">
                        </el-table-column>

<!--                        <el-table-column-->
<!--                            prop="maintainer"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            width="100"-->
<!--                            label="维护人">-->
<!--                        </el-table-column>-->
                        <el-table-column
                                prop="legalPerson"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="联系人">
                        </el-table-column>
                      <el-table-column
                          prop="telephone"
                          :show-overflow-tooltip="true"
                          label="联系方式">
                      </el-table-column>
<!--                      <el-table-column-->
<!--                          prop="email"-->
<!--                          :show-overflow-tooltip="true"-->
<!--                          label="邮箱">-->
<!--                      </el-table-column>-->
<!--                        <el-table-column-->
<!--                            prop="custagentChannelName"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            width="120"-->
<!--                            label="客户所属渠道">-->
<!--                        </el-table-column>-->
                      <el-table-column
                          prop="user"
                          :show-overflow-tooltip="true"
                          label="用户(业主)">
                      </el-table-column>
                        <el-table-column
                            prop="infoSource"
                            :show-overflow-tooltip="true"
                            label="信息来源">
                            <template slot-scope="scope">
                                {{scope.row.infoSource|dictname('info_source')}}
                            </template>
                        </el-table-column>
<!--                        <el-table-column-->
<!--                            prop="isIntention"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            label="是否意向客户">-->
<!--                            <template slot-scope="scope">-->
<!--                                {{scope.row.isIntention|dictname('shifou_keyong')}}-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                      <el-table-column-->
<!--                          prop="signingType"-->
<!--                          :show-overflow-tooltip="true"-->
<!--                          label="建议签约类型">-->
<!--                           <template slot-scope="scope">-->
<!--                              {{scope.row.signingType|dictname('contract_type_custagent')}}-->
<!--                          </template>-->
<!--                      </el-table-column>-->
<!--                        <el-table-column-->
<!--                            prop="estimateNum"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            label="预计签约金额(万元)">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column-->
<!--                            prop="estimateContractDate"-->
<!--                            width="120"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            label="预计签约时间">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column-->
<!--                            prop="dataSource"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            label="数据来源">-->
<!--                        </el-table-column>-->

<!--                        <el-table-column-->
<!--                            prop="clueFromName"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            label="线索来源">-->
<!--                        </el-table-column>-->

                        <el-table-column
                            prop="cdate"
                            :show-overflow-tooltip="true"
                            width="110"
                            :formatter="formatDate"
                            label="创建时间">
                        </el-table-column>
                        <el-table-column
                            prop="cuname"
                            :show-overflow-tooltip="true"
                            width="110"
                            label="创建人">
                        </el-table-column>

                        <el-table-column
                            prop="countSign"
                            label="累计跑动次数"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <div>
                                    <el-button type="text" @click="lookDetail(scope.row)">{{
                                        scope.row.countSign
                                        }}</el-button>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="100">
                            <template slot-scope="scope">
                                <div class="w-caozuo" style="text-align: left;">
                                    <el-button
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn" @click="update(scope.row)">
                                        修改
                                    </el-button>
                                    <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="savePress(scope.row)"
                                    >催办</el-button>
                                </div>
                            </template>
                        </el-table-column>



                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                                       icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" v-if="isImport"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="bscPartnerHighSeasExcel"
                                    :startrow="2"
                                    :extparams="q"
                                    @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell" v-if="this.saveorupdate==1">
                            <h1>新增信息</h1>
                            <p>New</p>
                        </div>
                        <div class="h-tableCell" v-if="this.saveorupdate==2">
                            <h1>修改信息</h1>
                            <p>Update</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38">
                    <el-form :model="f" :rules="rules" ref="f"
                             :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                      <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode">
                        <brselect category="YLRegion" :v="f.areaCode" v-model="f.areaCode" :clearable="true"
                            @change="changeArea"
                        />
                      </el-form-item>
                        <el-form-item label="地市" class="h-elformWrap-2" prop="city">
                            <el-select v-model="f.city" filterable clearable
                                       placeholder="地市" style="width: 225px;"  >
                                <el-option
                                    v-for="item in cityList"
                                    :key="item.city"
                                    :label="item.city"
                                    :value="item.city">
                                </el-option>
                            </el-select>
                        </el-form-item>

                      <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode">
                        <brselect category="sales_region_ct" :v="f.channelCode" v-model="f.channelCode" @change="changeChannel"
                                  :clearable="true"
                        />
                      </el-form-item>
                      <el-form-item label="客户名称" class="h-elformWrap-2" prop="customerName">
<!--                        <el-input v-model.trim="f.customerName" placeholder="请输入"/>-->
                        <el-select v-model="f.customerName"  remote  clearable placeholder="请输入" allow-create filterable default-first-option
                                     :remote-method="selectDept" @change="setDept">
                            <el-option v-for="(item) in deptNameList"
                                         :key="item.deptId"
                                         :label="item.deptName"
                                         :value="item.deptName">
                            </el-option>
                         </el-select>


                      </el-form-item>
<!--                      <el-form-item label="领域" class="h-elformWrap-2" prop="custagentFiled">-->
<!--                          <brselect category="swyl_field_custagent" :v="f.custagentFiled" v-model="f.custagentFiled" @change="changeCustagent" :clearable="true"-->
<!--                           />-->
<!--                      </el-form-item>-->
                       <el-form-item label="主要经营品牌" class="h-elformWrap-2" prop="majorBrands">
                            <el-input v-model.trim="f.majorBrands" placeholder="请输入"/>
                       </el-form-item>
<!--                        <el-form-item label="维护人" class="h-elformWrap-2" prop="maintainer">-->
<!--                            <el-input v-model.trim="f.maintainer" placeholder="请输入"/>-->
<!--                        </el-form-item>-->
                      <el-form-item label="联系人" class="h-elformWrap-2" prop="legalPerson">
                        <el-input v-model.trim="f.legalPerson" placeholder="请输入"/>
                      </el-form-item>
                      <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                        <el-input v-model.trim="f.telephone" placeholder="请输入" maxlength="20"
                                  oninput="value=value.replace(/[^\d]/g,'')"/>
                      </el-form-item>
<!--                      <el-form-item label="邮箱" class="h-elformWrap-2" prop="email">-->
<!--                        <el-input v-model.trim="f.email" placeholder="请输入"/>-->
<!--                      </el-form-item>-->
<!--                        <el-form-item label="客户所属渠道" class="h-elformWrap-2" prop="custagentChannel">-->
<!--                            <brselect category="channel_custagent" :v="f.custagentChannel" v-model="f.custagentChannel" @change="changeKhchannel" :clearable="true"-->
<!--                            />-->
<!--                        </el-form-item>-->
                      <el-form-item label="用户(业主)" class="h-elformWrap-2" prop="user">
                        <el-input v-model.trim="f.user" placeholder="请输入"/>
                      </el-form-item>
                        <el-form-item label="信息来源" class="h-elformWrap-2" prop="infoSource" >
                            <brselect category="info_source" :v="f.infoSource" v-model="f.infoSource" />
                        </el-form-item>

<!--                      <el-form-item label="是否意向客户" class="h-elformWrap-2" prop="isIntention"  v-if="this.saveorupdate==2">-->
<!--                          <brselect category="shifou_keyong" :v="f.isIntention" v-model="f.isIntention"  @change="changeIntention" />-->
<!--                      </el-form-item>-->

<!--                      <el-form-item label="建议签约类型" class="h-elformWrap-2" prop="signingType" v-if="f.isIntention=='1'"  >-->
<!--                          <brselect category="contract_type_custagent" :v="f.signingType" v-model="f.signingType" :clearable="true"/>-->
<!--                      </el-form-item>-->
<!--                        <el-form-item label="预计签约金额(万元)" class="h-elformWrap-2" prop="estimateNum" v-if="f.isIntention=='1'" >-->
<!--                            <el-input v-model.trim="f.estimateNum" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g,'')"/>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="预计签约时间" class="h-elformWrap-2" prop="estimateContractDate" v-if="f.isIntention=='1'" >-->
<!--                            <el-date-picker type="date"  value-format="yyyy-MM-dd" placeholder="选择日期" v-model="f.estimateContractDate" style="width: 100%;"></el-date-picker>-->
<!--                        </el-form-item>-->

                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert">提交
                    </el-button>
                </div>
            </el-dialog>

            <!-- 查看累计跑动记录 -->
            <el-dialog
                title=""
                :visible.sync="runningFlag"
                :fullscreen="false"
                width="70%"
                :modal="true"
                :before-close="handleClose"
                class="h-dialog2"
            >
                <h3>&nbsp;</h3>
                <div class="tanBox">
                    <el-table
                        :data="tableDatahi"
                        border
                        max-height="420"
                        style="width: 94%; margin: 0 auto"
                    >
                        <el-table-column label="序号" type="index" fixed width="50">
                        </el-table-column>
                        <el-table-column prop="userCode" label="工号" width="100">
                        </el-table-column>
                        <el-table-column
                            prop="userName"
                            label="姓名"
                            width="100"
                        ></el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="签到时间"
                            width="150"
                        ></el-table-column>
                        <el-table-column
                            prop="signOutTime"
                            label="签退时间"
                            width="150"
                        ></el-table-column>
                        <el-table-column
                            prop="departmentName"
                            label="科室"
                            width="120"
                        ></el-table-column>
                        <el-table-column
                            prop="deptPersonName"
                            label="联系人"
                            width="100"
                        ></el-table-column>
                        <el-table-column
                            prop="signPoint"
                            label="拜访目标"
                            :show-overflow-tooltip="true"
                            width="100"
                        ></el-table-column>
                        <el-table-column
                            prop="signContent"
                            label="拜访记录"
                            :show-overflow-tooltip="true"
                            width="200"
                        ></el-table-column>
                        <el-table-column
                            prop="signDeptName"
                            label="用户单位"
                            :show-overflow-tooltip="true"
                            width="200"
                        ></el-table-column>
                    </el-table>
                </div>
                <div
                    style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 20px;
        "
                >
                    <paginationmin :page="mf" @query="handleMessage" />
                </div>
            </el-dialog>

            <!--线索催办弹出框-->
            <el-dialog :close-on-click-modal="false" :visible.sync="cluepressDialog" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>{{titleDig}}</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;">
                        <el-form :model="pressLog" label-position="right" :inline="true"  label-width="180"
                                 class="demo-ruleForm h-formbLine  h-formbLine1">
                            <el-form-item label="催办日期" prop="pressDate" >
                                <el-input
                                    v-model="pressLog.pressDate" :disabled="true" style="width: 190px;">
                                </el-input>
                            </el-form-item>

                            <el-form-item  label="催办原因" class="h-elformWrap-1" prop="pressContent">
                                <el-input type="textarea" v-model="pressLog.pressContent" placeholder="请输入" class="h-txtareaBox" rows="3" clearable></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="closeCluePress">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="press()">提交</el-button>
                    </div>
                </div>
                <template>
                    <el-table :data="pressLogTable" border style="width: 100%">
                        <el-table-column label="序号" type="index" width="55"></el-table-column>
                        <el-table-column prop="cuname" label="催办人" width="70"></el-table-column>
                        <el-table-column prop="pressDate" label="催办日期" width="140"></el-table-column>
                        <el-table-column prop="pressContent" label="催办原因" >
                            <template slot-scope="scope">
                                <el-tooltip placement="top">
                                    <div slot="content" width="200"><pre align="left"  style="max-width: 500px;white-space: pre-wrap;">{{scope.row.pressContent}}</pre></div>
                                    <pre align="left" >{{scope.row.pressContent}}</pre>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pressUserName" label="接收人" width="345" >
                        </el-table-column>
                    </el-table>
                </template>

            </el-dialog>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import highseas from "../../../api/loud/partnerhighseas/partnerhighseas";
    import _ from "loadsh";

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {

                //表格
                multipleSelection: [],
                canjobpoint:true,
                isImport:false,
                //导入Excel
                uploaddownexcelflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                areaList:[],
                channelList:[],//渠道
                custagentList:[],//领域
                channelKhList:[],//客户渠道
                //临时的id
                iditem:'',
                userInfo: {
                    usercode: null,
                    username: null,
                },
                //分页/检索
                q: {
                    jobGroup:null,
                    jobUsercode:null,
                    dataSource:null,
                    cstartDate:null,
                    cendDate:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f:{
                    areaCode: null,
                    area: null,
                    city:null, //城市 new
                    channel: null,
                    channelCode: null,
                    customerName: null,
                    legalPerson: null,//法人
                    custagentFiled: null,//领域 new
                    custagentName: null,//领域名称 new
                    majorBrands: null,//主要经营品牌 new
                    maintainer: null,//维护人 new
                    telephone: null,//联系方式
                    email: null,//邮箱
                    user: null,//用户
                    signingType: null,//签约类型
                    custagentChannel: null,//客户所属渠道  new
                    custagentChannelName: null,//客户所属渠道名称  new
                    estimateContractDate: null,//预计签约时间 new
                    estimateNum:null,//预计签约金额(万元) new
                    isIntention:null,  //是否意向客户 new
                    infoSource :null,  //信息来源 new


                },
                //客户信息
                deptNameList:[],
                //链群
                JobGroup: [],
                JobPoint:[],
                //table列表
                tableData: [],
                cityList: [],      //城市list
                //弹窗
                dialogFormVisible: false,
              rules: {
                areaCode:[{required: true, message: '区域必填', trigger: 'change'}],
                channelCode:[{required: true, message: '渠道必填', trigger: 'change'}],
                customerName:[{required: true, message: '客户名称必填', trigger: 'change'}],
                legalPerson:[{required: true, message: '法人必填', trigger: 'change'}],
                telephone:[{required: true, message: '联系方式必填', trigger: 'change'}],
                city: [{required: true, message: '请选择地市', trigger: 'blur'}],
                custagentFiled: [{required: true, message: '请选择领域', trigger: 'blur'}],
                majorBrands: [{required: true, message: '请输入主要经营品牌', trigger: 'blur'}],
                custagentChannel: [{required: true, message: '请选择客户所属渠道', trigger: 'blur'}],


              },
              tableDatahi: [], // 跑动详情列表
              runningFlag: false, // 累计跑动详情
              mf: {
                pageSize: 10,
                pageNo: 1,
                total: 0
              },
              cluepressDialog : false, // 催办
              titleDig:"",
              pressLog:{
                id: '',
                mainId: '',
                pressDate: '',
                pressContent: '',
                pnum: '',
                cuname: '',
                ids:[],
              },
              //催办详情
              pressLogTable:[],
            }
        },
        created() {
            this.query();
            this.selectJobGroup();
            this.channelList = this.$store.getters.dictlist("sales_region_ct");//渠道


            this.areaList = this.$store.getters.dictlist("YLRegion");
            this.isImport = this.$store.getters.hasRole('swyl_admin,swyl_wanglgly,agent_hehuoren_daoru');
        },
        methods: {
            //节点筛选可用
            okJobPoint(){
                if(this.q.jobGroup!=null){
                    this.canjobpoint = false;
                    ss.xietongguanli.selectDeptPoint(this.q.jobGroup).then(rd => {
                        this.JobPoint = rd;
                    });
                }else{
                    this.canjobpoint = true;
                    this.q.jobPoint = null;
                }
            },
            //部门列表
            selectJobGroup() {
                ss.xietongguanli.selectDeptPoint().then(rd => {
                    this.JobGroup = rd;
                });
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.customerCode = null;
                this.q.area = null;
                this.q.channel = null;
                this.q.user = null;
            },
            query() {
                ss.highseas.selectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //新增
            adduser() {
                this.saveorupdate = 1
                this.f.id = null;
                this.f.jobGroup = null;
                this.f.jobUsername = null;
                this.f.jobUsercode = null;
                this.f = {};
                this.dialogFormVisible = true;
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.id = null;
                this.f.jobGroup = null;
                this.f.jobUsername = null;
                this.f.jobUsercode = null;
                this.f = {};
                this.$refs[formName].resetFields();
            },
            //新增
            insert() {
                var subflag = false;

                //如果是意向客户 签约字段必填
                if(this.f.isIntention=="1"){
                    if(!this.f.signingType){
                        this.$msg.msge("请选择签约类型!");
                        return false;
                    }
                    if(!this.f.estimateNum){
                        this.$msg.msge("请填写预计签约金额!");
                        return false;
                    }
                    if(!this.f.estimateContractDate){
                        this.$msg.msge("请填写预计签约时间!");
                        return false;
                    }

                }

                console.log(this.f,"1111111111111")
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    ss.highseas.updateById(this.f).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                        this.dialogFormVisible = false;
                    })
                }
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //删除
            handleDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.xietongguanli.deleteDept(value.id).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                    });
                });
            },
            //修改
            update(value) {
              this.saveorupdate = 2;
                ss.highseas.selectById(value.id).then(rd => {
                    console.log(rd,"rdrdrdrdrdrdrd");
                    this.dialogFormVisible = true;
                    this.f = rd.obj;
                })
            },
            //根据用户编码获取用户信息
            getUserName(){
                var usercode = this.f.jobUsercode;
                ss.UserService.selectById(usercode).then(rd => {
                    console.log("getUserName",rd)
                    this.f={
                        id:this.iditem,
                        jobUsercode:rd.obj.usercode,
                        jobUsername:rd.obj.username,
                        jobGroup:this.f.jobGroup,
                    }
                    console.log("getUserName123",rd)
                })
            },
            deleteSelete() {
              var idlist = [];
              this.multipleSelection.forEach(element => {
                idlist.push(element.id);
              });
              console.log(idlist)
              this.deleteSingle(idlist)
            },
            deleteSingle(id) {
              console.log("id", id)
              var data = id
              this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                ss.highseas.deleteList(data).then(res => {
                  console.log(res)
                  if (res.f == true) {
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                    this.query()
                  } else {
                    this.$message.error(res.msg);
                  }
                })

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });

            },
            //选择区域
            changeArea(value){
                if(value != null && value != ''){
                    console.log(value.name,"name");
                    ss.customer.getAreaCity(value.name).then(rd => {
                        console.log(rd);
                        this.cityList = rd;
                    })
                }else {
                    this.cityList = [];
                }
                this.$set(this.f,'city','')

                this.f.area = value.name;
            },

            //选择渠道
            changeChannel(value){
                this.f.channel = value.name;

            },
            //选择领域
            changeCustagent(value){
                this.f.custagentName= value.name;

            },
            //选择客户渠道
            changeKhchannel(value){
                this.f.custagentChannelName = value.name;
            },
            //是否意向客户
            changeIntention(value){
                if(value.code==0){
                    this.$set(this.f,'signingType','');
                    this.$set(this.f,'estimateNum','');
                    this.$set(this.f,'estimateContractDate','');
                }
            },
            //获取单位名称信息
            selectDept(value){
                ss.nxAddress.getDeptList(value).then(rd =>{
                    this.deptNameList = rd.msg;
                })
            },
            //获取单位名称信息
            setDept(value){
                console.log("123123",value);
                let dept = _.find(this.deptNameList,{deptName:value})
                ss.nxAddress.getTelByWl(value).then(rd =>{
                    if(rd.msg !=null){
                        this.$set(this.f,'telephone',rd.msg.telephone)
                        this.$set(this.f,'email',rd.msg.email)
                        this.$set(this.f,'legalPerson', dept.legalPerson)
                        console.log(  this.f.legalPerson );
                    }else{
                        this.$set(this.f,'telephone','')
                        this.$set(this.f,'email','')
                        this.$set(this.f,'legalPerson','')
                    }

                })


            },

            // 查看详情
            lookDetail(val) {
                console.log(val);
                this.runningFlag = true;
                let data = {
                    pageSize: 10,
                    pageNo: 1,
                    userUnitName: val.customerName
                }

                ss.grabOrderApi.selectSignContentPage(data).then((res) => {
                    this.tableDatahi = res.records;
                    this.mf.total = res.total;
                });
            },
            //关闭弹出框
            handleClose(v) {
                this.mf.pageNo = 1;
                v();
            },
            //查询跑动
            handleMessage() {
                this.mf.userUnitName = this.userUnitName
                ss.grabOrderApi.selectSignContentPage(this.mf).then((res) => {
                    this.mf.total = res.total;
                    this.tableDatahi = res.records;
                });
            },

            //批量导出
            exportExcel() {
                var strids = _.join(_.map(this.multipleSelection,"id"),",");

                this.q.ids = strids;
                updownfile.down("/api/swyl/v1/demo/bscPartnerHighSeas/downloadExcel", this.q, "post");
            },

            addZero(i) {
                if (i < 10) {
                    i = "0" + i;
                }
                return i;
            },
            getDate() {
                var d = new Date();
                var month = this.addZero(d.getMonth()+1)
                var day = this.addZero(d.getDate())
                var h = this.addZero(d.getHours());
                var m = this.addZero(d.getMinutes());
                var s = this.addZero(d.getSeconds());
                return d.getFullYear()+"-"+month+"-"+day+" "+ h + ":" + m + ":" + s;
            },
            //催办
            savePress(row){
                this.titleDig="催办"
                this.pressLog.mainId = row.id;
                this.pressLog.pressDate = this.getDate();
                this.selectCluepress();
                this.cluepressDialog = true
            },
            //根据id查询催办
            selectCluepress(){
                ss.highseas.selectPressLog(this.pressLog.mainId).then(res =>{
                    this.pressLogTable = res.obj;
                })
            },
            //关闭提交催办
            closeCluePress(){
                this.cluepressDialog = false,
                this.pressLog.mainId = '',
                this.pressLog.pressDate = '',
                this.pressLog.pressContent = ''
            },
            //催办
            press(){

                this.$confirm('您确定要催办?', '催办', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    ss.highseas.press(this.pressLog).then(res =>{
                        if (res.f == true){
                            this.$message({
                                type: 'success',
                                message: '催办成功!'
                            });
                            this.query();
                            this.closeCluePress();
                        }else {
                            this.$message({
                                type: 'error',
                                message: '催办失败!'
                            });;
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消!'
                    });
                });
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
        }
    }
</script>


<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
    width:110px;
    }
    /deep/  .h-formbLine .el-form-item__content{
    width:350px;
    }

</style>


<style>


    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .el-table tbody td:last-child{
        border-left: 1px solid #c2d2db;
    }
</style>
